'use client';

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import React, { ComponentProps, useId } from 'react';
// eslint-disable-next-line no-restricted-imports
import { Tooltip as ReactTooltip } from 'react-tooltip';
import TooltipContent from '@/components/atoms/TooltipContent';
import { InfoIcon } from '@/public/assets/svg';
import { InfoTooltipProps } from './types';
const OPEN_EVENTS: ComponentProps<typeof ReactTooltip>['openEvents'] = {
  click: true,
  focus: true,
  mouseenter: true,
  mousedown: true
};
const InfoTooltip = t0 => {
  const $ = _c(12);
  const {
    title,
    description
  } = t0;
  const id = useId();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      backgroundColor: "white",
      borderRadius: ".375rem"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = title || undefined;
  const t3 = description || "";
  let t4;
  if ($[1] !== t2 || $[2] !== t3) {
    t4 = <TooltipContent title={t2} description={t3} data-sentry-element="TooltipContent" data-sentry-source-file="index.tsx" />;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== id || $[5] !== t4) {
    t5 = <ReactTooltip id={id} style={t1} openEvents={OPEN_EVENTS} border="1px solid var(--gray-200)" data-sentry-element="ReactTooltip" data-sentry-source-file="index.tsx">{t4}</ReactTooltip>;
    $[4] = id;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== id) {
    t6 = <InfoIcon className="text-primary-600 h-5 w-5 cursor-pointer hover:opacity-50" data-tooltip-id={id} data-sentry-element="InfoIcon" data-sentry-source-file="index.tsx" />;
    $[7] = id;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};
export default InfoTooltip;